import React from 'react';
import { styled } from '@mui/system';
import { TableCell } from '@mui/material';
import SortingColumn from '#component/table/sorting-column';
import measurementsIcon from '#component/icon/measurements';
import IconTemperature from '#component/icon/temperature';

export const DeviceTitleCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    // width={280}
    width="auto"
    id="title"
    title="Name"
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

const StyledBatteryCell = styled(TableCell)(() => ({
  '& svg': {
    verticalAlign: 'middle'
  }
}));

export const DeviceChargeCell = () => (
  <StyledBatteryCell
    align="left"
    width={110}
  >
    {measurementsIcon('battery', '', 80)}
  </StyledBatteryCell>
);

export const DeviceTemperatureCell = () => (
  <TableCell align="left" width={70}>
    <IconTemperature style={{ verticalAlign: 'middle' }} fill="currentColor" />
  </TableCell>
);

export const DeviceEventCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="event"
    title="Event"
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const DeviceDetailsCell = ({ account }) =>
  account?.userType < 10 && <TableCell align="left" width={80}>Details</TableCell>;

export const DeviceQRCell = () => <TableCell align="left" width={80}>QR</TableCell>;
